import React from 'react';
import { Link } from 'react-router-dom';

const LogoProcessor: React.FC = () => {
  return (
    <Link to="/" className="flex items-center">
      <img
        src="/countedcare-logo.png"
        alt="CountedCare Logo"
        className="h-8 w-auto"
        loading="eager"
      />
    </Link>
  );
};

export default LogoProcessor;